// src/pages/AllProductsPage/AllProductsPage.js
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaSearch } from 'react-icons/fa';
import './AllProductsPage.css';

const AllProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/products')
      .then((res) => setProducts(res.data))
      .catch((err) => console.error('שגיאה בטעינת כל המוצרים:', err));
  }, []);

  const handleAddToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const alreadyInCart = cart.find(item => item.id === product.id);

    if (!alreadyInCart) {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: JSON.parse(product.images)[0]
      });
      localStorage.setItem('cart', JSON.stringify(cart));
    }

    alert('המוצר נוסף לסל ✔');
  };

  const handleBuyNow = (product) => {
    handleAddToCart(product);
    navigate('/cashout');
  };

  return (
    <>
<Helmet>
  <title>AutoPro - החנות הכי חמה לקיץ!</title>
  <meta
    name="description"
    content="מוצרי קיץ מדהימים: גאדג'טים, אביזרי חוף, מאווררים ניידים, בקבוקי מים קרים, שמשיות, ציוד קמפינג, ועוד המון! AutoPro – קיץ שלא תשכח."
  />
  <meta
    name="keywords"
    content="מוצרי קיץ, חנות קיץ, גאדג'טים לקיץ, שמשיות, מאוורר נייד, אביזרים לחוף, AutoPro, חנות אונליין, מבצעים לקיץ"
  />
  <meta name="author" content="AutoPro.co.il" />

  {/* Open Graph */}
  <meta property="og:title" content="AutoPro - חנות מוצרי קיץ חכמה" />
  <meta
    property="og:description"
    content="כל מה שצריך לקיץ שלך: איכות, סטייל ומבצעים חמים. AutoPro מביאים לך קיץ מושלם בלחיצת כפתור."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://autopro.co.il/products" />
  <meta property="og:image" content="https://autopro.co.il/og-image.jpg" />
  <meta property="og:site_name" content="AutoPro" />
  <meta property="og:locale" content="he_IL" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="AutoPro - קיץ מושלם מתחיל כאן!" />
  <meta
    name="twitter:description"
    content="המוצרים הכי חמים לקיץ! שמשיות, גאדג'טים, ציוד חוף, מאווררים, ועוד – AutoPro החנות של הקיץ."
  />
  <meta name="twitter:image" content="https://autopro.co.il/og-image.jpg" />
  <meta name="twitter:site" content="@AutoPro" />

  <link rel="canonical" href="https://autopro.co.il/products" />

  {products.length > 0 && (
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "מוצרי קיץ - AutoPro",
        itemListElement: products.map((product, index) => ({
          "@type": "Product",
          position: index + 1,
          name: product.name,
          image: JSON.parse(product.images)[0],
          description: product.description,
          offers: {
            "@type": "Offer",
            priceCurrency: "ILS",
            price: product.price,
            availability: "https://schema.org/InStock",
            url: `https://autopro.co.il/product/${product.id}`
          }
        }))
      })}
    </script>
  )}
</Helmet>


<div className="all-products-containerAllProductPage">
  <div className="shop-headerAllProductPage">
    <h1 className="all-products-titleAllProductPage">AutoPro</h1>
    <p className="shop-subtitleAllProductPage">
      ברוך הבא ל-AutoPro – החנות הכי חמה של הקיץ! ☀️ <br />
      גאדג'טים, אביזרי קיץ, ציוד לבריכה וים, פתרונות קירור, שמשיות ועוד – הכל באיכות גבוהה ובמחירים מרעננים במיוחד.
    </p>
  </div>


        <div className="search-barAllProductPage">
          <p className="SearchAllProductPagep">חיפוש חופשי</p>
          <div className="search-input-wrapperAllProductPage">
            <FaSearch className="search-iconAllProductPage" />
            <input
              type="text"
              placeholder="חפש מוצר"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-inputAllProductPage"
            />
          </div>
        </div>

        <div className="products-gridAllProductPage">
          {products
            .filter((product) => {
              const term = searchTerm.toLowerCase();
              return (
                product.name.toLowerCase().includes(term) ||
                product.description?.toLowerCase().includes(term) ||
                product.moreinfo?.toLowerCase().includes(term)
              );
            })
            .map((product) => {
              const image = JSON.parse(product.images)[0];
              return (
                <div key={product.id} className="product-cardAllProductPage">
                  <div
                    className="product-image-wrapperAllProductPage"
                    onClick={() => navigate(`/product/${product.id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <img
                      src={image}
                      alt={product.name}
                      className="product-imageAllProductPage"
                    />
                  </div>

                  <h2
                    className="product-nameAllProductPage"
                    onClick={() => navigate(`/product/${product.id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    {product.name}
                  </h2>

                  <p className="product-short-descriptionAllProductPage">
                    {product.description?.slice(0, 50)}...
                  </p>

                  <p className="product-priceAllProductPage">{product.price} ₪</p>

                  <div className="product-buttonsAllProductPage">
                    <button
                      className="buy-now-btnAllProductPage"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleBuyNow(product);
                      }}
                    >
                      קנה עכשיו
                    </button>

                    <button
                      className="add-to-cart-btnAllProductPage"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddToCart(product);
                      }}
                    >
                      הוסף לסל
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default AllProductsPage;
